import { call, put, takeLatest, all } from 'redux-saga/effects'
import { handleApiErrors } from '../../lib/api-errors'
import * as Constants from './constants'
import * as Actions from './actions'

const addRequestUrl = `${process.env.REACT_APP_WEB_API}/api/v1/assessments/addnewtest`;
const editRequestUrl = `${process.env.REACT_APP_WEB_API}/api/v1/assessments/edittest`;
const getRequestUrl = `${process.env.REACT_APP_WEB_API}/api/v1/assessments/get-test-data`;

function handleRequest (request) {
  return request
    .then(handleApiErrors)
    .then(response => response.json())
    .then(json => json)
    .catch((error) => { throw error })
}

function addRequestApi ({ data, pageMode }) {
  const request = fetch(pageMode === 'edit' ? editRequestUrl : addRequestUrl, {
    method: 'POST',
    headers: {
      authorization: localStorage.getItem("jwtToken"),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data),
  })

  return handleRequest(request)
}
function* addRequestFlow (action) {
  try {
    const result = yield call(addRequestApi, action)
    yield put(Actions.addSuccess(result))
  } catch (error) {
    yield put(Actions.addError(error))
  }
}

function getRequestApi ({ testId }) {
  const request = fetch(getRequestUrl, {
    method: 'POST',
    headers: {
      authorization: localStorage.getItem("jwtToken"),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ test_id: testId }),
  })

  return handleRequest(request)
}
function* getRequestFlow (action) {
  try {
    const result = yield call(getRequestApi, action)
    yield put(Actions.getSuccess(result))
  } catch (error) {
    yield put(Actions.getError(error))
  }
}

function* addWatcher () {
  yield all([
    takeLatest(Constants.ADD_REQUEST, addRequestFlow),
    takeLatest(Constants.GET_REQUEST, getRequestFlow),
  ]);
}

export default addWatcher
